import { create } from 'zustand'

export interface TipsState {
  enabled: boolean
  toggle: () => void
}

function safeGet(key: string): string | null {
  try { return localStorage.getItem(key) } catch { return null }
}
function safeSet(key: string, val: string): void {
  try { localStorage.setItem(key, val) } catch { /* private browsing */ }
}

const useTipsStore = create<TipsState>((set) => ({
  enabled: safeGet('sw-tips') === 'true',
  toggle: () => set((state) => {
    const next = !state.enabled
    safeSet('sw-tips', String(next))
    return { enabled: next }
  }),
}))

export default useTipsStore
